import { NgModule } from '@angular/core';
import { MessagesService } from '@services/chat-persistence/messages.service';
import { MessageStoreService } from '@modules/chat/store/message-store.service';
import { GroupStoreService } from '@modules/chat/store/group-store.service';
import { ChatListenersService } from '@services/listeners/chat-listeners.service';
import { MessageGroupStoreService } from '@modules/chat/store/message-group-store.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [MessagesService, MessageStoreService, MessageGroupStoreService, GroupStoreService, ChatListenersService],
})
export class ChatListenerModule {}
